<section>
  <div class="hero" [ngStyle]="{'background-image': 'url('+ image +');'}">
  </div>
  <div class="title"><ng-content></ng-content></div>

</section>